<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
    <p v-if="showError" class="text-danger ml-2 pl-1 mb-1">{{ $t('login.error') }}</p>
    <b-form-group label-for="mail">
      <b-form-input :placeholder="$t('login.mail.label')" id="mail" v-model="mail" type="email" required :state="$v.mail.$dirty ? !$v.mail.$error : null" @blur="$v.mail.$touch"></b-form-input>
    </b-form-group>
    <b-form-group label-for="pass">
      <!-- validation errors of password are not displayed as the behavior makes no sense for the user -->
      <b-form-input :placeholder="$t('login.pass.label')" id="pass" v-model="pass" type="password" required :state="null"></b-form-input>
      <p class="ml-2 pl-1 mt-1">
        <b-link class="text-primary" to="/password-reset">{{ $t('password_reset.title') }}</b-link>
      </p>
    </b-form-group>
    <b-button class="d-block w-100" type="submit" variant="primary">{{ $t('login.submit') }}</b-button>
    <p class="ml-2 pl-1 mt-1">
      {{ $t('login.register_intro') }}
      <b-link class="text-primary" to="/register">{{ $t('login.register_label') }}</b-link>
    </p>
  </b-form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'LoginForm',
  data () {
    return {
      mail: null,
      pass: null,
      showError: false
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      if (!this.$v.$error) {
        return this.$login()
      }
      return false
    }
  },
  validations: {
    mail: {
      required,
      email
    },
    pass: {
      required
    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
